/**
 * Text-to-speech readback for קוֹל. Opt-in (default off), because Hebrew TTS
 * voice quality varies by platform. Used for eyes-busy / driving contexts.
 */

export function isTtsSupported(): boolean {
  return typeof window !== 'undefined' && 'speechSynthesis' in window;
}

export function speak(text: string, lang = 'he-IL'): void {
  if (!isTtsSupported() || !text.trim()) return;
  const synth = window.speechSynthesis;
  synth.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = lang;
  u.rate = 1;
  u.pitch = 1;
  const voice = synth.getVoices().find((v) => v.lang && v.lang.toLowerCase().startsWith('he'));
  if (voice) u.voice = voice;
  synth.speak(u);
}

export function cancelSpeech(): void {
  if (isTtsSupported()) window.speechSynthesis.cancel();
}
